<!-- <div class="loader_wrap"><app-loader-component *ngIf="!setLoadingState"></app-loader-component></div> -->
<app-loader-component *ngIf="setLoadingState"></app-loader-component>

<div class="bar-chart" *ngIf="!setLoadingState && !_isAnnual">
   <app-ratios-chart [chartKey]="chartKey"></app-ratios-chart>
</div>
<div class="bar-chart" *ngIf="!setLoadingState && _isAnnual">
   <app-ratio-annual-chart [chartKey]="chartKey" [price_to_earning]="price_to_earning"></app-ratio-annual-chart>
</div>
<ul class="annual_quater_tab" *ngIf="!setLoadingState">
   <!-- <li [class.active]="_isAnnual" (click)="changePeriod(true)">
      <i class="icon-annual"></i> Annual
   </li>
   <li [class.active]="!_isAnnual" (click)="changePeriod(false)">
      <i class="icon-quaterly"></i> Quarterly
   </li> -->
   <li [class.active]="_isAnnual" (click)="changePeriod(true)">
      <img [src]="_isAnnual ? 'assets/icons/annual-green.svg' : 'assets/icons/annual-grey.svg'" alt="Annual Icon">
      Annual
   </li>

   <li [class.active]="!_isAnnual" (click)="changePeriod(false)">
      <img [src]="!_isAnnual ? 'assets/icons/quaterly-green.svg' : 'assets/icons/quaterly-grey.svg'"
         alt="Quarterly Icon">
      Quarterly
   </li>
</ul>


<div class="table-responsive" *ngIf="!setLoadingState">
   <app-ratios-table [_isAnnual]="_isAnnual" [allDataAnnual]="allDataAnnual" [aDataQuarterly]="aDataQuarterly"
      [bDataQuarterly]="bDataQuarterly" [cDataQuarterly]="cDataQuarterly" [dDataQuarterly]="dDataQuarterly"
      [price_to_earning]="price_to_earning"></app-ratios-table>
</div>
